<template>
  <div class="firefighting-right-button-wrap">
    <div class="btn-items scrollbar-none">
      <template v-for="btn in btns">
        <div
          v-if="btn.show()"
          class="firefighting-right-button_item"
          :class="{ 'is-active': isActive(btn.key) }"
          :key="btn.text"
          @click="open(btn.key)"
          @mouseover="handleMouseover(btn.key, $event)"
          @mouseleave="hidePopover"
        >
          <img :src="btn.icon" :alt="btn.text" />
          <span>{{ btn.text }}</span>
        </div>
      </template>
    </div>

    <MPopover
      :visible="visible"
      :position="popopPosition"
      @mouseover.native="showPopover"
      @mouseleave.native="hidePopover"
    >
      <div class="company-list">
        <ul>
          <li
            v-for="office in offices"
            :class="{
              active: subKey === office.key
            }"
            :key="office.id"
            @click="handleSwitchCompany(office)"
          >
            {{ office.name }}
          </li>
        </ul>
      </div>
    </MPopover>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// import { officeTypeDict } from '@/utils/const/office';
import { isEmpty } from '@/utils/is';
import MPopover from '@/components/mPopover/index.vue';

const prefix = '/static/image/cotton/';

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  components: { MPopover },

  data() {
    return {
      subKey: '',
      offices: [
        {
          name: '设备地图',
          key: 'firefightingMonitorBMap'
        },
        {
          name: '设备列表',
          key: 'firefightingMonitorList'
        }
      ],
      visible: false,
      popopPosition: {},
      btns: [
        {
          text: '实时监测',
          key: 'firefightingMonitor',
          icon: `${prefix}realtime-monitoring.png`,
          show: () => true
        },
        {
          text: '监测记录',
          key: 'firefightingBaleMonitoringRecord',
          show: () => true,
          icon: `${prefix}detection-record.png`
        },
        {
          text: '检测记录',
          key: 'firefightingBaleDetectionRecord',
          show: () => true,
          icon: `${prefix}detection-stat.png`
        },

        {
          text: '报警记录',
          key: 'firefightingBaleAlarmRecord',
          icon: `${prefix}alarm-record.png`,
          show: () => true
        },
        // {
        //   text: '检测统计',
        //   key: 'firefightingDetectionStat',
        //   icon: `${prefix}detection-stat.png`,
        //   show: () => true
        // },
        {
          text: '报警统计',
          key: 'firefightingAlarmStat',
          icon: `${prefix}alarm-stat.png`,
          show: () => true
        },
        {
          text: '危险物信息',
          key: 'firefightingDangerousGoodsInfo',
          icon: `${prefix}dangerous-goods.png`,
          show: () => true
        }
      ]
    };
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
    ...mapState('socket', ['deviceTree', 'deviceIdMap'])
  },
  methods: {
    isActive(key) {
      return this.activeMenu.indexOf(key) !== -1;
    },
    open(key) {
      if (this.activeMenu === key) return;

      if (key === 'firefightingMonitor') {
        this.visible = !this.visible;
      }

      this.$router.push({
        name: key
      });
    },
    showPopover() {
      if (this.timer) clearTimeout(this.timer);

      this.visible = true;
    },
    hidePopover() {
      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.visible = false;
      }, 300);
    },
    handleMouseover(key) {
      if (key !== 'firefightingMonitor') return;

      this.showPopover();

      this.popopPosition = {
        left: 0,
        top: '20px',
        transform: 'translateX(-100%)'
      };
    },
    handleSwitchCompany(office) {
      this.hidePopover();

      this.$router.push({
        name: office.key
      });
    }
  },
  watch: {
    deviceTree: {},
    '$route.params': {
      handler() {
        const id = this.$route.params.id;

        if (isEmpty(id)) return;

        this.model.officeType = this.deviceIdMap[id].type;

        this.model.officeId = id;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.firefighting-right-button-wrap {
  border: 2px solid #047eba;
  border-radius: 110px;
  backdrop-filter: blur(4px);
  width: var(--aside-bar-width);
  height: calc(100% - var(--header-height) - 15px);

  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  gap: 15px;

  padding: var(--aside-bar-padding);

  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 7;

  .btn-items {
    width: 100%;
    // height: 100%;

    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;

    .firefighting-right-button_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      width: 100%;

      cursor: pointer;

      transition: all 0.3s;

      &.is-active {
        filter: brightness(1.5);
        scale: 1.1;

        span {
          font-weight: 600;
          color: #318eff;
        }
      }

      &:hover {
        filter: brightness(1.5);
      }

      img {
        width: 90%;
      }

      span {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: var(--aside-bar-font-size);
        color: #fff;
        line-height: 23px;

        transition: all 0.3s;
      }
    }
  }

  .company-list {
    height: 100%;

    --title-height: 38px;

    &_title {
      height: var(--title-height);
      line-height: var(--title-height);
      text-align: center;
      font-size: 16px;
    }

    ul {
      height: calc(100% - var(--title-height) - 2px);
      overflow: auto;
      @include scrollar-style-thin;

      li {
        width: 100%;
        padding-left: 10%;
        line-height: 36px;
        box-sizing: border-box;
        position: relative;

        cursor: pointer;

        &:hover,
        &.active {
          background: #185e9c;
        }

        &.is-alarm {
          background: #ff4847;
        }

        &.active {
          &::before {
            content: '';

            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);

            width: 3px;
            height: 3px;

            background: #fff;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
